import { createSlice } from "@reduxjs/toolkit";
import { IOrderPayload } from "../../types/Warehouses/sales";

export interface State {
  payload: IOrderPayload;
}

const slice = createSlice({
  name: "orderFilters",
  initialState: { payload: {} } as State,
  reducers: {
    orderFilters: (state, { payload }: State) => {
      state.payload = payload;
    }
  }
});

export const { orderFilters } = slice.actions;
export default slice.reducer;
